import axios from 'axios'
import React, {  useState } from 'react'
import { motion } from "framer-motion"


const Login = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [data, setData] = useState('')
    const [reveal, setReveal] = useState(false)

    const myVariant = {
        hidden: {
            scale: 1
        },
        visible: {
            scale: 1.1,
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 10
            }
        }
    }

    const getPosts = async () => {
        try {
        const response = await axios.get('https://portfolio-api-rz8v.onrender.com/users', {
            headers: {
                admin:process.env.REACT_APP_PASSWORD
            }
        })
        setData(response.data)
    } catch (error) {
        console.log(error)
    }
}
    const deletePosts = async () => {
        try {
         await axios.delete('https://portfolio-api-rz8v.onrender.com/users', {
            headers: {
                admin:process.env.REACT_APP_PASSWORD
            }
         })
         setData("")

    } catch (error) {
        console.log(error)
    }
}
    
    

    const handleClick = () => {
        if (username === process.env.REACT_APP_USERNAME && password === process.env.REACT_APP_PASSWORD) {
            setReveal(true)
            getPosts()
        } else {
            alert("you are not the admin!")
        }
    }
    const handleDelete = () => {
        if (username === process.env.REACT_APP_USERNAME && password === process.env.REACT_APP_PASSWORD) {
            deletePosts()
        } else {
            alert("you are not the admin!")
        }
    }
    
    
    
    return (
        <div >
            {!reveal ?
            <form className='login'>
                <h1>login</h1>
                <input placeholder='username' type="text" value={username} onChange={e => setUsername(e.target.value)} />
                <input placeholder='password' type="password" value={password} onChange={e => setPassword(e.target.value)} />
                <motion.button
                    variants={myVariant}
                    initial={'hidden'}
                    whileHover={'visible'}
                        onClick={() => handleClick()}
                        type='button'
                >login</motion.button>
            </form>
                :
                <div className='posts'>
                    <button className='btn' onClick={handleDelete}>delete all</button>
            {data && data.map(post => {
                return (
                    <div key={post._id} className='post'>
                        
                        <h1>{post.username} <i className="fa-solid fa-arrow-right mx-5"></i></h1>
                        <p>{post.comment}</p>
                        
                    </div>
                )
            })}
            </div>
        }
        </div>
    )
};

export default Login